<template>
  <div
    class="klaviyo-bis-drawer"
    :class="`${namespace}__klaviyo-bis`"
  >
    <template v-if="showFormOnly">
      <klaviyo-bis-form
        :accepts-marketing="acceptsMarketing"
        :cta-text="ctaText"
        :display-text="displayText"
        :product="product"
        :variant="variant"
        @update-email="handleUpdateEmail"
        @form-submitted="$emit('form-submitted')"
      />
    </template>

    <template v-else>
      <button
        v-if="showCloseButton"
        type="button"
        class="klaviyo-bis-drawer__btn text-body-2xs-regular"
        @click="handleCloseDrawer"
      >
        <template v-if="showCloseIcon">
          <span class="klaviyo-bis-drawer__close-icon">
            <icon-close />
          </span>
        </template>

        <template v-else>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon icon__chevron"
            width="7"
            height="12"
            viewBox="0 0 7 12"
            fill="none"
            role="presentation"
          >
            <path
              d="M6 1L1 6L6 11"
              stroke="black"
            />
          </svg>

          <span v-text="$string('product.back_in_stock.back')" />
        </template>
      </button>

      <p
        class="klaviyo-bis-drawer__heading text-body-2xs-regular"
        v-text="$string( 'product.back_in_stock.heading', {
          replace: { size: sizeValue }
        })"
      />

      <klaviyo-bis-form
        :accepts-marketing="acceptsMarketing"
        :cta-text="ctaText"
        :display-text="displayText"
        :product="product"
        :variant="variant"
        @update-email="handleUpdateEmail"
        @form-submitted="$emit('form-submitted')"
      />

      <div class="klaviyo-bis-drawer__footer">
        <p
          class="klaviyo-bis-drawer__privacy-policy"
          v-html="footerText || $string('product.back_in_stock.privacy_policy_html')"
        />
      </div>
    </template>
  </div>
</template>

<script>

/**
 * Vue: Klaviyo back in stock (klaviyo-bis-form)
 * -----------------------------------------------------------------------------
 * Klaviyo back in stock form.
 *
 * @param {String} ctaText - Text shown in Klaviyo form CTA
 * @param {String} displayText - Text shown in Klaviyo toggle form CTA
 * @param {String} footerText - Text shown in Klaviyo drawer footer
 * @param {String} namespace - Namespace of parent component
 * @param {Boolean|Null|Object} product - Canvas formatted product object.
 * @param {Boolean|Null|Object} variant - Canvas formatted variant object.
 * @param {String} sizeValue - Value of size to be shown in drawer heading
 * @param {Boolean} showCloseButton - Show close button in drawer
 * @param {Boolean} showCloseIcon - Show close icon instead of text in drawer
 * @param {Boolean} showFormOnly - Only displays Klaviyo form
 */

import IconClose from '~icons/directional-navigation/close-outline.svg'
import KlaviyoBisForm from '~async/klaviyo-bis/klaviyo-bis-form'

export default {
  name: 'KlaviyoBisDrawer',

  components: {
    IconClose,
    KlaviyoBisForm,
  },

  props: {
    ctaText: {
      type: String,
      default: '',
    },
    displayText: {
      type: String,
      default: '',
    },
    footerText: {
      type: String,
      default: '',
    },
    namespace: {
      type: String,
      default: '',
    },
    product: {
      type: [Boolean, null, Object],
      default: false,
      required: true,
    },
    variant: {
      type: [Boolean, null, Object],
      default: false,
      required: true,
    },
    sizeValue: {
      type: String,
      default: '',
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    showCloseIcon: {
      type: Boolean,
      default: false,
    },
    showFormOnly: {
      type: Boolean,
      default: false,
    },
  },

  emits: {
    'close-drawer': () => true,
    'form-submitted': () => true,
  },

  data() {
    return {
      formEmail: true,
      acceptsMarketing: false,
    }
  },

  methods: {

    /**
     * Handle back in stock drawer back button
     */
    handleCloseDrawer() {
      this.$emit('close-drawer')
    },

    /**
     * Handle form email update
     * @param {String} email - form email input value
     */
    handleUpdateEmail(email) {
      this.formEmail = email
    },
  },
}
</script>

<style lang="scss">
@import './klaviyo-bis-drawer';
</style>
